import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_PRINCIPAL_URL, REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets the list of Regions types.
 */
export const getRegion = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/geografia/region`)
})

/**
 * Gets the identity by the given DNI.
 */
export const getIdentity = factoryService(({ dni }) => {
  return getJsonRequest(
    `${REACT_APP_API_PRINCIPAL_URL}/v1/usuario-registro/informacionPersona/${dni}?origen=trato-directo-front&validaFallecido=false`
  )
})

/**
 * Gets the identity by the given Provider.
 */
export const getProvider = factoryService(({ providerDni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/organismo/proveedor?rutProveedor=${providerDni}`)
})

/**
 * Gets the information about the given Provider.
 */
export const getProviderPricing = factoryService(({ providerDni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/organismo/proveedor/${providerDni}`)
})

/**
 * Gets the Regions and Cities.
 */
export const getRegionsAndCities = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/parametros/comunas`)
})

/**
 * Gets the UTM value
 */
export const getUTM = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/parametros/utm`)
})

/**
 * Gets the units measurements
 */
export const getUnitsMeasurements = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/catalogo/unidades`)
})

/**
 * Gets all currencies
 */
export const getAllCurrencies = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/parametros/amounts`)
})

/**
 * Gets the Ability by the given Provider.
 */
export const getProviderAbility = factoryService(({ providerDni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/info-habilidad/${providerDni}`)
})

/**
 * Gets the Ability by the given Provider v2.
 */
export const getProviderAbilityV2 = factoryService(({ providerDni, isForeign }) => {
  const dni = normalizeDniSlashes(providerDni)

  return getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v3/proveedor/habilidad/${dni}/${isForeign}`)
})
/**
 * POST: publish a direct deal sheet
 */
export const getLawsuitCauses = factoryService(({ directDealId }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/demandas/${directDealId}`)
})
/**
 * Gets alerts
 */
export const getNotificationsConfig = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/trato-directo/parametros/marquesina`)
})
